import { useState } from "react";
import "./VVLCampaign.scss";

const customers = [
  { id: "huber", company: "Malerbetrieb Huber", name: "Lisa Huber", plan: "Smart Business M", days: 9 },
  { id: "schmidt", company: "Bäckerei Schmidt GmbH", name: "Anna Schmidt", plan: "Business Prime M", days: 21 },
  { id: "wagner", company: "Kanzlei Wagner & Partner", name: "Jan Wagner", plan: "Business Prime XL", days: 45 },
  { id: "keller", company: "Autohaus Keller", name: "Tim Keller", plan: "Business Prime L", days: 75 },
];

const channels = ["E-Mail", "SMS", "WhatsApp"] as const;

const defaultMessage =
  "Hallo {Name}, Ihre Vertragsverlängerung steht in {Tage} Tagen an. Wir haben ein passendes Angebot für Sie – sollen wir einen Termin vereinbaren?";

export default function VVLCampaign() {
  const [selectedIds, setSelectedIds] = useState<string[]>(customers.map((customer) => customer.id));
  const [channel, setChannel] = useState<(typeof channels)[number]>("E-Mail");
  const [message, setMessage] = useState(defaultMessage);
  const [showDemoNotice, setShowDemoNotice] = useState(false);

  const previewCustomer = customers.find((customer) => selectedIds.includes(customer.id));
  const preview = previewCustomer
    ? message.replace(/\{Name\}/g, previewCustomer.name).replace(/\{Tage\}/g, String(previewCustomer.days))
    : "Wählen Sie einen Kunden für die Vorschau aus.";

  function toggleCustomer(id: string) {
    setSelectedIds((previous) =>
      previous.includes(id) ? previous.filter((selectedId) => selectedId !== id) : [...previous, id],
    );
    setShowDemoNotice(false);
  }

  return (
    <main className="vvl-campaign">
      <header className="vvl-campaign__header">
        <h1>VVL-Kampagnen</h1>
        <p>Fällige Bestandskunden auswählen und gesammelt ansprechen.</p>
      </header>

      <div className="vvl-campaign__columns">
        <section className="vvl-campaign__card vvl-campaign__customers" aria-labelledby="vvl-campaign-customers-heading">
          <h2 id="vvl-campaign-customers-heading">Fällig in den nächsten 90 Tagen ({customers.length})</h2>

          <div className="vvl-campaign__customer-list">
            {customers.map((customer) => (
              <label className="vvl-campaign__customer" key={customer.id}>
                <input
                  type="checkbox"
                  checked={selectedIds.includes(customer.id)}
                  onChange={() => toggleCustomer(customer.id)}
                />
                <span className="vvl-campaign__customer-details">
                  <span className="vvl-campaign__customer-company">{customer.company}</span>
                  <span className="vvl-campaign__customer-meta">{customer.name} · {customer.plan}</span>
                </span>
                <span className={`vvl-campaign__days ${customer.days <= 30 ? "vvl-campaign__days--urgent" : ""}`}>
                  {customer.days} Tage
                </span>
              </label>
            ))}
          </div>
        </section>

        <section className="vvl-campaign__card vvl-campaign__message" aria-labelledby="vvl-campaign-message-heading">
          <h2 id="vvl-campaign-message-heading">Nachricht</h2>

          <div className="vvl-campaign__channels" role="group" aria-label="Nachrichtenkanal">
            {channels.map((option) => (
              <button
                key={option}
                type="button"
                className={`vvl-campaign__channel ${channel === option ? "vvl-campaign__channel--active" : ""}`}
                aria-pressed={channel === option}
                onClick={() => setChannel(option)}
              >
                {option}
              </button>
            ))}
          </div>

          <textarea
            className="vvl-campaign__editor"
            aria-label="Nachrichtentext"
            value={message}
            onChange={(event) => {
              setMessage(event.target.value);
              setShowDemoNotice(false);
            }}
          />

          <div className="vvl-campaign__preview" aria-live="polite">
            <span className="vvl-campaign__preview-label">
              {previewCustomer ? `Vorschau für ${previewCustomer.name}` : "Vorschau"}
            </span>
            <p>{preview}</p>
          </div>

          <button
            className="vvl-campaign__send"
            type="button"
            disabled={selectedIds.length === 0}
            onClick={() => setShowDemoNotice(true)}
          >
            An {selectedIds.length} Kunden senden (Demo)
          </button>
          {showDemoNotice && <p className="vvl-campaign__notice" role="status">Demo-Modus: Es wurden keine Nachrichten versendet.</p>}
        </section>
      </div>
    </main>
  );
}
